module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay",
    staticStyle: {
      "opacity": "1.09",
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    staticStyle: {
      "display": "block",
      "margin-top": "-191px"
    },
    attrs: {
      "data-custom-class": "",
      "data-has-cancel-button": "true",
      "data-has-confirm-button": "true",
      "data-allow-outside-click": "false",
      "data-has-done-function": "true",
      "data-animation": "pop",
      "data-timer": "null"
    }
  }, [_c('em', {
    staticClass: "sa-icon sa-info icon-exclamation"
  }), _vm._v(" "), _c('h2', {
    staticClass: "modal-title "
  }, [_vm._v(_vm._s(_vm.modalTitle))]), _vm._v(" "), _c('p', {
    staticClass: "modal-paragraph"
  }, [_vm._v("\n          " + _vm._s(_vm.questionText) + "\n          "), (_vm.hyperLinkUrl && _vm.hyperLinkText) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.hyperLinkUrl
    }
  }, [_vm._v(" " + _vm._s(_vm.hyperLinkText) + " ")]) : _vm._e(), _vm._v(" "), (_vm.hyperLinkUrl2 && _vm.hyperLinkText2) ? _c('span', [_vm._v(" and ")]) : _vm._e(), _vm._v(" "), (_vm.hyperLinkUrl2 && _vm.hyperLinkText2) ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.hyperLinkUrl2
    }
  }, [_vm._v(" " + _vm._s(_vm.hyperLinkText2) + " ")]) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.questionTextAppend) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons"
  }, [_vm._t("body", [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [(!_vm.hideCancelButton) ? _c('button', {
    staticClass: "btn btn-info btn-lg btn-cancel",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.hideQuestionModal()
      }
    }
  }, [_vm._v("Cancel")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg btn-accept",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.executeAction()
      }
    }
  }, [_vm._v(_vm._s(_vm.yesButtonText) + "\n                ")])])])])], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-194c1c3d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/Question.vue
// module id = 2110
// module chunks = 1